import React from "react";
import PropTypes from "prop-types";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faQuestionCircle,
  faCheckCircle,
  faTimes,
  faCheck,
  faQuestion,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import CandidateCard from "../shared/candidate/CandidateCard";

library.add(
  faQuestionCircle,
  faCheckCircle,
  faTimes,
  faCheck,
  faQuestion,
  faExclamationTriangle
);

const cardState = ({
  status,
  action,
  actionAt,
  isRecruiter,
  feedbackOverdue,
}) => {
  if (status === "new-update") {
    return { candidateUpdates: "arrow-circle-right", tooltip: action };
  }
  if (status === "accepted" && action === "Competency test completed") {
    return { candidateUpdates: "check-circle", tooltip: action };
  }
  if (status === "accepted") {
    return {
      candidateUpdates: "check-circle",
      tooltip: `Confirmed: ${actionAt}`,
    };
  }
  if (status === "successful") {
    return { candidateUpdates: "check", tooltip: "Successful candidate" };
  }
  if (status === "unsuccessful") {
    return { candidateUpdates: "check", tooltip: "Unsuccessful" };
  }
  if (status === "offered") {
    return { candidateUpdates: "question", tooltip: action };
  }
  if (!isRecruiter && feedbackOverdue) {
    return {
      candidateUpdates: "exclamation-triangle",
      tooltip: "Feedback is overdue",
    };
  }
  return { candidateUpdates: "times", tooltip: "" };
};

const KanbanCandidateCard = (props) => {
  const {
    card,
    dispatch,
    isRecruiter,
    index,
    id,
    handleMakeOffer,
    handleJobOffer,
    handleRecruiterConfirmation,
  } = props;
  const { candidateUpdates, tooltip } = cardState({ isRecruiter, ...card });

  return (
    <CandidateCard
      candidateUpdates={candidateUpdates}
      tooltip={tooltip}
      index={index}
      id={id}
      dispatch={dispatch}
      isRecruiter={isRecruiter}
      handleMakeOffer={handleMakeOffer}
      handleJobOffer={handleJobOffer}
      handleRecruiterConfirmation={handleRecruiterConfirmation}
      {...card}
    />
  );
};

KanbanCandidateCard.propTypes = {
  card: PropTypes.shape({
    action: PropTypes.string,
    actionAt: PropTypes.string,
    action_at: PropTypes.string,
    added: PropTypes.string,
    agent: PropTypes.string,
    candidate: PropTypes.string,
    column: PropTypes.string,
    createActionLink: PropTypes.string,
    duplicateLink: PropTypes.string,
    feedbackOverdue: PropTypes.bool,
    id: PropTypes.number.isRequired,
    link: PropTypes.string,
    status: PropTypes.string,
    unreadLink: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  isRecruiter: PropTypes.bool,
  handleMakeOffer: PropTypes.func,
  handleJobOffer: PropTypes.func,
  handleRecruiterConfirmation: PropTypes.func,
};

KanbanCandidateCard.defaultProps = {
  isRecruiter: PropTypes.bool.isNull,
  handleMakeOffer: PropTypes.isNull,
  handleJobOffer: PropTypes.isNull,
  handleRecruiterConfirmation: PropTypes.isNull,
};

export default KanbanCandidateCard;
